var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdsenseLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1400 1250",
    role: "img",
    "aria-label": "Google AdSense",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC04",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M924.088,355.003c66.14-113.208,26.869-257.89-87.701-323.278 C721.769-33.57,575.256,5.137,509.116,118.345c-2.915,5.072-5.657,10.243-8.221,15.502L277.297,516.36 c-4.947,7.604-9.525,15.442-13.717,23.487L31.385,940.539l414.925,232.57l231.02-397.31c5.034-7.55,9.615-15.393,13.716-23.487 l223.598-382.56C917.887,364.961,921.129,360.076,924.088,355.003"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M448.237,1171.889c-65.764,115.04-214.11,157.364-328.023,90.99 C6.254,1196.456-34.191,1052.432,31.62,937.439s212.841-157.505,326.801-91.13c113.96,66.422,155.579,210.586,89.815,325.533"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1343.617,430.726c-113.259-65.272-257.977-26.619-323.607,86.433 L783.117,926.494c-65.267,112.821-26.717,257.189,86.104,322.456c0.204,0.118,0.407,0.235,0.611,0.352 c113.281,65.296,258.039,26.617,323.654-86.48l236.845-409.288c65.257-112.856,26.671-257.246-86.185-322.503 C1343.97,430.929,1343.793,430.827,1343.617,430.726"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdsenseLogo);
export default __webpack_public_path__ + "static/media/adsense-logo.08578484399777712fa8533cf914b82b.svg";
export { ForwardRef as ReactComponent };